// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TextSearchPatternOrItemList } from "../text-search-pattern-or-item-list";
import { TextSearchPattern } from "../text-search-pattern";
import { DateSearchRange } from "../date-search-range";
import { SearchRequestBase } from "./base/search-request-base";

export class MessageSearchRequest extends SearchRequestBase {
	public From: TextSearchPatternOrItemList = new TextSearchPatternOrItemList();
	public To: TextSearchPatternOrItemList = new TextSearchPatternOrItemList();
	public Subject: TextSearchPattern = new TextSearchPattern();
	public SentOn: DateSearchRange = new DateSearchRange();
}